import { useRef } from "react";
import { Card, Badge, Dot } from "./ui";
import { ESTADOS, ESTADO_COLORS, INTERES_META, fmtMoney, day } from "./store";

export const Pipeline = ({ data, upsertLead }) => {
  const { leads } = data;
  const dragId = useRef(null);

  const moveTo = (estado) => {
    const id = dragId.current;
    if (!id) return;
    const lead = leads.find((l) => l.id === id);
    if (!lead || lead.estado === estado) return;
    upsertLead({
      ...lead,
      estado,
      interacciones: [...lead.interacciones, { fecha: day(0), tipo: "Email", resumen: `Etapa actualizada a "${estado}" desde el pipeline.` }],
    });
  };

  const activos = leads.filter((l) => l.estado !== "Cerrado");
  const valorTotal = activos.reduce((s, l) => s + (Number(l.unidades) || 0) * 59600, 0);

  return (
    <div className="space-y-5">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        <Card className="p-5">
          <p className="text-xs text-gray-500">Valor total pipeline</p>
          <p data-testid="pipeline-valor" className="mt-1 text-2xl font-bold text-gray-900">{fmtMoney(valorTotal)}</p>
        </Card>
        <Card className="p-5">
          <p className="text-xs text-gray-500">Leads activos</p>
          <p data-testid="pipeline-activos" className="mt-1 text-2xl font-bold text-gray-900">{activos.length}</p>
        </Card>
        <Card className="border-emerald-100 bg-emerald-50/50 p-5">
          <p className="text-xs text-emerald-700">Cerrados</p>
          <p data-testid="pipeline-cerrados" className="mt-1 text-2xl font-bold text-emerald-700">{leads.length - activos.length}</p>
        </Card>
      </div>

      <div className="flex gap-4 overflow-x-auto pb-4" data-testid="kanban-board">
        {ESTADOS.map((estado) => {
          const col = leads.filter((l) => l.estado === estado);
          return (
            <div
              key={estado}
              data-testid={`kanban-col-${estado}`}
              onDragOver={(e) => e.preventDefault()}
              onDrop={() => moveTo(estado)}
              className="w-64 shrink-0 rounded-2xl bg-gray-100/70 p-3"
            >
              <div className="mb-3 flex items-center gap-2 px-1">
                <Dot color={ESTADO_COLORS[estado]} />
                <span className="text-sm font-semibold text-gray-800">{estado}</span>
                <span data-testid={`kanban-count-${estado}`} className="ml-auto rounded-full bg-white px-2 py-0.5 text-xs font-medium text-gray-500">{col.length}</span>
              </div>
              <div className="min-h-[120px] space-y-2.5">
                {col.map((l) => (
                  <div
                    key={l.id}
                    data-testid={`kanban-card-${l.id}`}
                    draggable
                    onDragStart={() => { dragId.current = l.id; }}
                    className="cursor-grab rounded-xl border border-gray-100 bg-white p-3.5 shadow-sm transition-shadow hover:shadow-md active:cursor-grabbing"
                  >
                    <p className="text-sm font-medium text-gray-900">{l.nombre}</p>
                    <div className="mt-2 flex items-center justify-between">
                      <Badge className={INTERES_META[l.interes]?.chip || ""}><Dot color={INTERES_META[l.interes]?.dot || "#999"} />{l.interes}</Badge>
                      <span className="text-[11px] text-gray-400">{l.unidades}u · {fmtMoney(l.unidades * 59600)}</span>
                    </div>
                    {l.proximaAccion && <p className="mt-2 truncate text-[11px] text-gray-500" title={l.proximaAccion}>→ {l.proximaAccion}</p>}
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
      <p className="text-xs text-gray-400">Arrastra las tarjetas entre columnas o abre un lead para cambiar su etapa. Los cambios se guardan al instante para todo el equipo.</p>
    </div>
  );
};
